import { render, staticRenderFns } from "./GenericChart.vue?vue&type=template&id=3360794b&scoped=true"
import script from "./GenericChart.vue?vue&type=script&lang=js"
export * from "./GenericChart.vue?vue&type=script&lang=js"
import style0 from "./GenericChart.vue?vue&type=style&index=0&id=3360794b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3360794b",
  null
  
)

export default component.exports